import React from "react";
import GenericButton from "../../common/genericButton";
import GenericModal from "../../common/genericModal";
import GenericInput2 from "../../common/GenericInput2";
import styles from "./Recieve.module.scss";
import { Link } from "react-router-dom";

const Recieve = ({ isOpen, toggle }) => {
  const changeHandler = () => {};
  return (
    <>
      <GenericModal isOpen={isOpen} toggle={toggle}>
        <div className={styles.img}>
          <img src="/assets/bitcoin-logo.png" alt="bit-coin" />
        </div>
        <div className={styles.mainheading}>Receive BTC</div>

        <div className={styles.scanimg}>
          <img src="/assets/Group 2.png" alt="bit-coin" className={styles.img2} />
        </div>

        <div className={styles.text}>
          <Link to="">
            <a>Use the address below to receive funds.</a>
          </Link>
        </div>

        <div className={styles.fieldWrapper}>
          <GenericInput2
            label={"Your Bitcoin Address"}
            placeholder="bc1qv72zvy3ev890sr8hht5635mzk0lttzzfwg8z0t"
            type="text"
            withRightIcon={"/assets/copy.png"}
            name="email"
            onChange={changeHandler}
            icon={false}
          />
        </div>

        <div className={styles.buttonWrapper}>
          <GenericButton title={"Share"} icon={"/assets/Path.png"}/> 
        </div>
      </GenericModal>
    </>
  );
};

export default Recieve;
